import React, { useEffect, useState } from 'react';
import { Pagination, ResultCount } from '@uhg-abyss/web/ui/Pagination';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { pagerNumberEvent } from '../../events';

const SpaceBetween = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const PagerBottom = ({ controller, headlessEngine }) => {
  const [pager, setPager] = useState(controller.state);

  useEffect(() => {
    controller.subscribe(() => setPager(controller.state));
  }, [controller]);
  return (
    <SpaceBetween>
      <ResultCount
        pageSize={headlessEngine.state.pagination.numberOfResults}
        pageIndex={pager.currentPage - 1}
        resultsTotalCount={headlessEngine.state.pagination.totalCountFiltered}
      />
      <Pagination
        gotoPage={(index) => {
          event.setData(
            pagerNumberEvent({
              searchPagination: index + 1,
              searchEventTrigger: 'pagerNumber',
            })
          );
          controller.selectPage(index + 1);
        }}
        previousPage={() => {
          event.setData(
            pagerNumberEvent({
              searchPagination: pager.currentPage - 1,
              searchEventTrigger: 'pagerNumber',
            })
          );
          controller.previousPage();
        }}
        nextPage={() => {
          event.setData(
            pagerNumberEvent({
              searchPagination: pager.currentPage + 1,
              searchEventTrigger: 'pagerNumber',
            })
          );
          controller.nextPage();
        }}
        pageCount={pager.currentPages[pager.currentPages.length - 1]}
        canNextPage={pager.hasNextPage}
        canPreviousPage={pager.hasPreviousPage}
        pageIndex={pager.currentPage - 1}
      />
    </SpaceBetween>
  );
};

PagerBottom.propTypes = {
  controller: PropTypes.shape({
    state: PropTypes.shape({
      currentPage: PropTypes.number,
      currentPages: PropTypes.arrayOf(PropTypes.string),
      hasNextPage: PropTypes.bool,
      hasPreviousPage: PropTypes.bool,
    }),
    subscribe: PropTypes.func.isRequired,
    selectPage: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
  }),
  headlessEngine: PropTypes.shape({
    state: {
      pagination: {
        numberOfResults: PropTypes.number,
        totalCountFiltered: PropTypes.number,
      },
    },
  }).isRequired,
};

PagerBottom.defaultProps = {
  controller: {
    state: {
      currentPage: 0,
      currentPages: [],
      hasNextPage: false,
      hasPreviousPage: false,
    },
  },
};
